import { render } from "./MySentIOUBackRequests.vue?vue&type=template&id=0c96039f&scoped=true"
import script from "./MySentIOUBackRequests.vue?vue&type=script&lang=js"
export * from "./MySentIOUBackRequests.vue?vue&type=script&lang=js"

import "./MySentIOUBackRequests.vue?vue&type=style&index=0&id=0c96039f&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c96039f"]])

export default __exports__